import { useCallback } from "react";
import { useNavigate } from "react-router";

/** 站点搜索的唯一出口：跳到素材库并带上关键词，由素材库页面完成检索。 */
export function useSiteSearch() {
  const navigate = useNavigate();
  return useCallback((keyword: string) => {
    const value = keyword.trim();
    navigate(value ? `/library?q=${encodeURIComponent(value)}` : "/library");
  }, [navigate]);
}
